/** The <h1> in the app header, and the document.title stem. */
export const PAGE_TITLES: Readonly<Record<string, string>> = {
  "/": "Home",
  "/account": "Account",
  "/settings": "Settings",
  "/team": "Team",
  "/team/policy": "Shared policy",
  "/team/api-keys": "API keys",
  "/billing": "Billing & invoices",
  "/subscription": "Subscription",
  "/signup": "Create your account",
  "/login": "Welcome back",
  "/reset": "Reset your password",
  "/reset/confirm": "Set a new password",
  "/verify": "Check your inbox",
  "/onboarding": "Install the extension",
  "/checkout": "Order summary",
  "/checkout/success": "You're all set",
  "/checkout/cancelled": "Checkout cancelled",
  "/404": "Page not found",
};

export const TITLE_SUFFIX = " · Prompt Gateway";
